import { Box, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

interface FeatureBannerHeadlineProps {
  color: string;
}

const FeatureBannerHeadline: React.FC<FeatureBannerHeadlineProps> = ({
  color,
  children,
}) => {
  const Styles = useMultiStyleConfig('FeatureBannerHeadline', { color });
  return <Box sx={Styles.container}>{children}</Box>;
};

export default FeatureBannerHeadline;
